import { Injectable } from '@angular/core';
import { CalculationBaseFormFactory } from '../../../base-form/form/base-form/calculation-base-form.factory';
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {
  RolloverNonShareConsiderationOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-non-share-consideration.options';
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import { FormFactory } from "@magieno/angular-advanced-forms";

@Injectable()
export class RolloverFormFactory extends CalculationBaseFormFactory {

  form: AdvancedForm<RolloverOptions>;

  constructor(protected readonly formFactory: FormFactory) {
    super(formFactory);
    this.optionsType = RolloverOptions;
  }

  init(form: AdvancedForm<RolloverOptions>) {
    this.form = form;
    if (this.form.value.nonShareConsiderations.length === 0) {
      (this.addNonShareConsideration().formElements.title as AdvancedFormControl<string, string, string>).setNormalizedValue('Billet à payer');
      (this.addNonShareConsideration().formElements.title as AdvancedFormControl<string, string, string>).setNormalizedValue('Hypothèque');
    }
  }

  addNonShareConsideration(): AdvancedFormGroup<RolloverNonShareConsiderationOptions> {
    return (this.form.formElements.nonShareConsiderations as AdvancedFormArray<RolloverNonShareConsiderationOptions>).appendNew();
  }

  // init(options?: RolloverOptions) {
  //     this.form = this.formFactory.createSubmittableForm(options ?? new RolloverOptions(), [
  //         new AdvancedFormButton("SAVE", ButtonStyleEnum.Light, "Sauvegarder", ButtonTypeEnum.Button, {shouldSubmitIfValidationFail: true}, faSave),
  //         new AdvancedFormButton("EXECUTE", ButtonStyleEnum.Primary, "Calculer", ButtonTypeEnum.Submit, {}, faPlay),
  //     ]);
  //
  //     if(this.getNonShareConsiderations().length === 0) {
  //         this.addNonShareConsideration().formElements.title.updateModel("Billet à payer");
  //         this.addNonShareConsideration().formElements.title.updateModel("Hypothèque");
  //     }
  // }


  // addShareClass() {
  //     const arrayForm: ArrayForm<RolloverSharesClassOptions> = this.form.formElements.sharesClasses as ArrayForm<RolloverSharesClassOptions>;
  //     arrayForm.add(this.formFactory.createForm(new RolloverSharesClassOptions()));
  // }
  //
  // removeShareClass(index: number) {
  //     (this.form.formElements.sharesClasses as ArrayForm<RolloverSharesClassOptions>).delete(index);
  // }
  //
  // getShareClassesFormElements(): BaseForm<RolloverSharesClassOptions>[] {
  //     return (this.form.formElements.sharesClasses as ArrayForm<RolloverSharesClassOptions>).getForms();
  // }
  //
  // getShareClassesSelectKeyValues(): {key: string, value: string}[] {
  //     return this.form.formElements.sharesClasses.getModel().map((shareClass) => ({key: shareClass.title, value: shareClass.id}));
  // }
  //
  // addShareClassShareholderDistribution(shareClass: BaseForm<RolloverSharesClassOptions>) {
  //     const arrayForm: ArrayForm<RolloverSharesClassShareholderDistributionOptions> = shareClass.formElements.shareholdersDistribution as ArrayForm<RolloverSharesClassShareholderDistributionOptions>;
  //     arrayForm.add(this.formFactory.createForm(new RolloverSharesClassShareholderDistributionOptions()));
  // }
  //
  // removeShareClassShareholderDistribution(shareClass: BaseForm<RolloverSharesClassOptions>, index: number) {
  //     (shareClass.formElements.shareholdersDistribution as ArrayForm<RolloverSharesClassShareholderDistributionOptions>).delete(index);
  // }
  //
  // getShareClassShareholderDistributionFormElements(shareClass: BaseForm<RolloverSharesClassOptions>): BaseForm<RolloverSharesClassShareholderDistributionOptions>[] {
  //     return (shareClass.formElements.shareholdersDistribution as ArrayForm<RolloverSharesClassShareholderDistributionOptions>).getForms();
  // }
  //
  // addPropertyTransferred() {
  //     const arrayForm: ArrayForm<RolloverPropertyTransferredOptions> = this.form.formElements.propertiesTransferred as ArrayForm<RolloverPropertyTransferredOptions>;
  //     arrayForm.add(this.formFactory.createForm(new RolloverPropertyTransferredOptions()));
  // }
  //
  // removePropertyTransferred(index: number) {
  //     (this.form.formElements.propertiesTransferred as ArrayForm<RolloverPropertyTransferredOptions>).delete(index);
  // }
  //
  // getPropertiesTransferred(): BaseForm<RolloverPropertyTransferredOptions>[] {
  //     return (this.form.formElements.propertiesTransferred as ArrayForm<RolloverPropertyTransferredOptions>).getForms();
  // }
  //
  // addPropertyTransferredNonShareConsideration(propertyTransferred: BaseForm<RolloverPropertyTransferredOptions>) {
  //     const arrayForm: ArrayForm<RolloverPropertyTransferredNonShareConsiderationOptions> = propertyTransferred.formElements.nonShareConsiderations as ArrayForm<RolloverPropertyTransferredNonShareConsiderationOptions>;
  //     arrayForm.add(this.formFactory.createForm(new RolloverPropertyTransferredNonShareConsiderationOptions()));
  // }
  //
  // removePropertyTransferredNonShareConsideration(propertyTransferred: BaseForm<RolloverPropertyTransferredOptions>, index: number) {
  //     (propertyTransferred.formElements.nonShareConsiderations as ArrayForm<RolloverPropertyTransferredNonShareConsiderationOptions>).delete(index);
  // }
  //
  // getPropertyTransferredNonShareConsiderations(propertyTransferred: BaseForm<RolloverPropertyTransferredOptions>): BaseForm<RolloverPropertyTransferredNonShareConsiderationOptions>[] {
  //     return (propertyTransferred.formElements.nonShareConsiderations as ArrayForm<RolloverPropertyTransferredNonShareConsiderationOptions>).getForms();
  // }
  //
  // addPropertyTransferredSharesClass(propertyTransferred: BaseForm<RolloverPropertyTransferredOptions>) {
  //     const arrayForm: ArrayForm<RolloverPropertyTransferredSharesClassOptions> = propertyTransferred.formElements.sharesClasses as ArrayForm<RolloverPropertyTransferredSharesClassOptions>;
  //     arrayForm.add(this.formFactory.createForm(new RolloverPropertyTransferredSharesClassOptions()));
  // }
  //
  // removePropertyTransferredSharesClass(propertyTransferred: BaseForm<RolloverPropertyTransferredOptions>, index: number) {
  //     (propertyTransferred.formElements.sharesClasses as ArrayForm<RolloverPropertyTransferredSharesClassOptions>).delete(index);
  // }
  //
  // getPropertyTransferredSharesClasses(propertyTransferred: BaseForm<RolloverPropertyTransferredOptions>): BaseForm<RolloverPropertyTransferredSharesClassOptions>[] {
  //     return (propertyTransferred.formElements.sharesClasses as ArrayForm<RolloverPropertyTransferredSharesClassOptions>).getForms();
  // }
  //
  // addShareholder() {
  //     const arrayForm: ArrayForm<RolloverShareholderOptions> = this.form.formElements.shareholders as ArrayForm<RolloverShareholderOptions>;
  //     arrayForm.add(this.formFactory.createForm(new RolloverShareholderOptions()));
  // }
  //
  // removeShareholder(index: number) {
  //     (this.form.formElements.shareholders as ArrayForm<RolloverShareholderOptions>).delete(index);
  // }
  //
  // getShareholders(): BaseForm<RolloverShareholderOptions>[] {
  //     return (this.form.formElements.shareholders as ArrayForm<RolloverShareholderOptions>).getForms();
  // }
  //
  // getShareholdersSelectKeyValues(): {key: string, value: string}[] {
  //     return this.form.formElements.shareholders.getModel().map((shareHolder) => ({key: shareHolder.title, value: shareHolder.id}));
  // }
  //
  // addNonShareConsideration(): BaseForm<RolloverNonShareConsiderationOptions> {
  //     const arrayForm: ArrayForm<RolloverNonShareConsiderationOptions> = this.form.formElements.nonShareConsiderations as ArrayForm<RolloverNonShareConsiderationOptions>;
  //     const nonShareConsiderationForm = this.formFactory.createForm(new RolloverNonShareConsiderationOptions());
  //     arrayForm.add(nonShareConsiderationForm);
  //     return nonShareConsiderationForm;
  // }
  //
  // removeNonShareConsideration(index: number) {
  //     (this.form.formElements.nonShareConsiderations as ArrayForm<RolloverNonShareConsiderationOptions>).delete(index);
  // }
  //
  // getNonShareConsiderations(): BaseForm<RolloverPropertyTransferredOptions>[] {
  //     return (this.form.formElements.nonShareConsiderations as ArrayForm<RolloverNonShareConsiderationOptions>).getForms();
  // }
  //
  // getNonShareConsiderationsSelectKeyValues(): {key: string, value: string}[] {
  //     return this.form.formElements.nonShareConsiderations.getModel().map((nonShareConsideration) => ({key: nonShareConsideration.title, value: nonShareConsideration.id}));
  // }

}
